import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { RouterModule } from '@angular/router'
import { InsuredNavigationItem } from '@app/layout/sidebar/models/insured-navigation-item.model'

@Component({
  selector: 'albert-list-view-insured-code-list-item',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './list-view-insured-code-list-item.component.html',
  styleUrl: './list-view-insured-code-list-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewInsuredCodeListItemComponent {
  public readonly itemClicked = output()
  public readonly bulkOptionsRequested = output<InsuredNavigationItem>()
  public readonly item = input.required<InsuredNavigationItem>()
  public readonly selected = input<boolean>(false)

  public onEntryClick(): void {
    this.itemClicked.emit()
  }

  public onContextMenu(event: MouseEvent): void {
    event.preventDefault()
    this.bulkOptionsRequested.emit(this.item())
  }
}
